<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title class="mt-8" title="Painel de cotações"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <v-row v-if="!loading && fornecedor">
      <v-col cols="12" sm="6">
        <px-meu-painel-avaliacao :fornecedor="fornecedor"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-meu-painel-score :fornecedor="fornecedor"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="6">
        <px-meu-painel-cotacoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6">
        <px-meu-painel-compras/>
      </v-col>
    </v-row>
    <px-survey target="FORNECEDOR"/>
  </div>
</template>

<script>
import MinhaPaginaService from '@/modules/minha-pagina/minha-pagina-service';
import MeuPainelCotacoes from './MeuPainelCotacoes.vue';
import MeuPainelCompras from './MeuPainelCompras.vue';
import MeuPainelAvaliacao from './MeuPainelAvaliacao.vue';
import MeuPainelScore from './MeuPainelScore.vue';

export default {
  data() {
    return {
      fornecedor: null,
      loading: false,
      breadcrumbs: [
        { text: 'Cotações' },
        { text: 'Painel de cotações' },
      ],
    };
  },
  methods: {
    getFornecedorScoreAvaliacao() {
      this.loading = true;
      MinhaPaginaService.get()
        .then(({ data }) => {
          this.fornecedor = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getFornecedorScoreAvaliacao();
  },
  components: {
    pxMeuPainelCotacoes: MeuPainelCotacoes,
    pxMeuPainelCompras: MeuPainelCompras,
    pxMeuPainelAvaliacao: MeuPainelAvaliacao,
    pxMeuPainelScore: MeuPainelScore,
  },
};
</script>
